import { createFileRoute } from '@tanstack/react-router';
import Permissions from '../../../administration/src/components/Apps/AppDetails/Permissions';

export const Route = createFileRoute('/_secured/administration/apps/$appId/permissions')({
  component: Permissions,
});
